import React from 'react'
import { useSelector } from 'react-redux';
import CalibrationCertificateList from '../../components/calibrationcertificatedetailcomponents/CalibrationCertificateList';


function CalibrationCertificateLists({renderPageContent}) {
    const headerName= useSelector(state => state.authendicationReducer.headerName); 

 
    if (headerName === 'Hospital Masters') {
      return (
          <>
              <CalibrationCertificateList renderPageContent={renderPageContent} />
          </>
      );
  } else {
      // If headerName doesn't match, return null or any other desired behavior
      return null; // or any other fallback component
  }
}
export default CalibrationCertificateLists
